import React from 'react';
import { FieldComponentProps, FieldType } from 'components/anvilFormFillable/fields/types';
import MaskedTextField from 'components/common/MaskedTextField';
import { placeholderByType } from 'components/anvilFormFillable/utils';
import InputAdornment from '@mui/material/InputAdornment';

const commonMaskRules = {
  mask: Number,
  min: 0,
  max: 999999999999999,
  scale: 2,
  radix: '.',
  padFractionalZeros: false,
  normalizeZeros: true,
  thousandsSeparator: ',',
  lazy: false,
};

const percentMask = [{
  mask: Number,
  min: 0,
  max: 100,
  radix: '.',
  lazy: false,
}];

const numberMask = [{
  ...commonMaskRules,
  scale: 2,
}];

const integerMask = [{
  ...commonMaskRules,
  scale: 0,
}];

const maskByType: Partial<Record<FieldType, Object[]>> = Object.freeze({
  integer: integerMask,
  percent: percentMask,
});

export default function NumberInput3({ field, value, onChange }: FieldComponentProps) {
  const { type, format } = field ?? {};
  const mask = maskByType[type] ?? numberMask;
  const isDecimal = /[.]/i.test(format ?? '');
  const placeholder = placeholderByType[type] ?? 'Please enter a number';
  return (
    <MaskedTextField
      unmask
      mask={mask}
      autoFocus
      value={value?.value ?? ''}
      onAccept={(data: string) => {
        onChange?.({ ...value, value: data });
      }}
      placeholder={isDecimal ? 'Please enter a number (e.g: 123.12)' : placeholder}
      className="border border-gray-100"
      InputProps={type === 'percent' ? {
        endAdornment: (
          <InputAdornment position="end">
            %
          </InputAdornment>
        ),
      } : {}}
    />
  );
}
